import {
  ControlProps,
  RankedTester,
  rankWith,
  scopeEndsWith,
} from "@jsonforms/core";
import {
  FormDetailItem,
  FormDetailValue,
  FormDetailWrapper,
} from "../../messageType/contentType/FormContent.style";
import React from "react";
import { withJsonFormsControlProps } from "@jsonforms/react";
import { formatDisplayPhoneNumber } from "hhn-commons";

const PhoneNumberWithCountryCodeViewRenderer = ({ data }: ControlProps) => {
  const phoneNumberWithCountryCode =
    data.countryCode && data.phoneNumber
      ? formatDisplayPhoneNumber(data.countryCode, data.phoneNumber.toString())
      : "N/A";
  return (
    <FormDetailWrapper data-testid="form-content-item">
      <FormDetailItem>Phone Number :</FormDetailItem>
      <FormDetailValue>{phoneNumberWithCountryCode}</FormDetailValue>
    </FormDetailWrapper>
  );
};

export const phoneNumberWithCountryCodeViewTester: RankedTester = rankWith(
  5,
  scopeEndsWith("phoneNumberWithCountryCode"),
);

export default withJsonFormsControlProps(
  PhoneNumberWithCountryCodeViewRenderer,
);
